import { createAction, props } from '@ngrx/store';
import { OptionModel } from 'src/app/shared/grid/filters/option.model';
import { CandidatePickle } from 'src/app/travelxnew/models/candidate-pickle.model';
import { Pickle } from '../../models/pickle.model';
import { CandidateContract } from 'src/app/travelxnew/models/candidate-contract.model';

export const getCandidatePickles = createAction(
    '[CANDIDATE PICKLES GRID COMPONENT] Get Candidate Pickles',
    props<{ candidateId: number }>()
);
export const getCandidatePicklesSuccess = createAction(
    '[CANDIDATE PICKLES API] Get Candidate Pickles Successfully',
    props<{ candidatePickles: CandidatePickle[] }>()
);
export const getCandidatePicklesFailure = createAction(
    '[CANDIDATE PICKLES API] Get Candidate Pickles Failure',
    props<{ error: string }>()
);

export const getPickleCategories = createAction('[PICKLE CATEGORIES] Get Pickle Categories');
export const getPickleCategoriesSuccess = createAction(
    '[PICKLE CATEGORIES] Get Pickle Categories Success',
    props<{ categories: OptionModel[] }>()
);
export const getPickleCategoriesFailure = createAction(
    '[PICKLE CATEGORIES] Get Pickle Categories Failure',
    props<{ error: string }>()
);

export const getPickleSources = createAction('[PICKLE SOURCES] Get Pickle Sources');
export const getPickleSourcesSuccess = createAction(
    '[PICKLE SOURCES] Get Pickle Sources Success',
    props<{ sources: OptionModel[] }>()
);
export const getPickleSourcesFailure = createAction(
    '[PICKLE SOURCES] Get Pickle Sources Failure',
    props<{ error: string }>()
);

export const setPickleContractsCandidate = createAction(
    '[PICKLE CONTRACTS] Set CandidateId Parameter',
    props<{ candidateId: number }>()
);

export const getPickleContractsByCandidateId = createAction(
    '[PICKLE CONTRACTS] Get Pickle Contracts',
    props<{ candidateId: number }>()
);
export const getPickleContractsByCandidateIdSuccess = createAction(
    '[PICKLE CONTRACTS] Get Pickle Contracts Success',
    props<{ contracts: CandidateContract[] }>()
);
export const getPickleContractsByCandidateIdFailure = createAction(
    '[PICKLE CONTRACTS] Get Pickle Contracts Failure',
    props<{ error: string }>()
);

export const submitPickle = createAction(
    '[SUBMIT PICKLE] Submit Pickle',
    props<{ candidateId: number; data: Pickle; isEdit: boolean }>()
);
export const submitPickleSuccess = createAction(
    '[SUBMIT PICKLE] Submit Pickle Success',
    props<{ candidateId: number; message: string }>()
);
export const submitPickleFailure = createAction('[SUBMIT PICKLE] Submit Pickle Failure', props<{ error: string }>());

export const setSelectedContract = createAction(
    '[PICKLE SELECTED CONTRACT] Set Selected Contract',
    props<{ contractId: number }>()
);
export const clearSelectedContract = createAction('[PICKLE SELECTED CONTRACT CLEARED] Clear Selected Contract');
export const setSelectedPickle = createAction(
    '[PICKLE SELECTED PICKLE] Set Selected Pickle',
    props<{ pickle: CandidatePickle }>()
);
export const clearSelectedPickle = createAction('[PICKLE SELECTED PICKLE CLEARED] Clear Selected Pickle');

export const deletePickle = createAction(
    '[DELETE PICKLE] Delete Pickle',
    props<{ candidateId: number; pickleId: number }>()
);
export const deletePickleSuccess = createAction(
    '[DELETE PICKLE] Delete Pickle Success',
    props<{ candidateId: number; message: string }>()
);
export const deletePickleFailure = createAction('[DELETE PICKLE] Delete Pickle Failure', props<{ error: string }>());
